var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',[_vm._v("iBowログイン")]),_c('div',{staticClass:"main-office-list"},_vm._l((_vm.corps),function(corp){return _c('Corp',{key:corp.id,attrs:{"corp":corp},on:{"update":_vm.fetch}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }